import React, {useState} from 'react'
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link } from 'react-router-dom';
import { SidebarData } from './Sidebardata.';
import './CSS/Navbar.css';
import { IconContext } from 'react-icons';
import IconButton from '@mui/material/IconButton';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useAuth } from './Authcontext';


function Navbar() {
    const[sidebar, setSidebar] = useState(false);
    const showSidebar = () =>setSidebar(!sidebar);
    const { logout } = useAuth();
    const handleLogout = () => {
      logout();
    };
  return (
    <>
    <IconContext.Provider value={{color: '#fff'}}>
        <div className="navbar">
            <Link to="#" className='menu-bars'>
              <FaIcons.FaBars onClick={showSidebar}/>
            </Link>
            
            <IconButton
              color="inherit"
              sx={{
                ml: "86%",
                display: "flex",
                alignItems: "center", // Center the text vertically
                color:"white" ,
              }}
             onClick={handleLogout}
            >
              <span style={{ marginRight: "8px", fontSize:"18px", color:"white" }}>Logout</span>
              <AccountCircleIcon />
            </IconButton>

        </div>
        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
            <ul className='nav-menu-items' onClick={showSidebar}>
            <li className='navbar-toggle'>
              <Link to='#' className='menu-bars'>
                <AiIcons.AiOutlineClose />
              </Link>
            </li>            
              {SidebarData.map((item, index)=> {
                return(
                  <li key={index} className={item.cName}>
                    <Link to={item.path}>
                      {item.icon}
                      <span>{item.title}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
        </nav>
      </IconContext.Provider>

    </>
  )
}

export default Navbar